import { makeStyles } from "tss-react/mui";

export const useStartseiteDynamischStyles = makeStyles()(() => ({}));
